import React from "react";
import { Collapse, Table, Empty, Badge } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { tabPaneStyle } from "../helpers/constants";

const { Panel } = Collapse;

interface RequiredDocumentsDisplayProps {
  provider: any;
  getDocumentName: (documentKey: string) => string;
}

export const RequiredDocumentsDisplay: React.FC<RequiredDocumentsDisplayProps> = ({
  provider,
  getDocumentName,
}) => {
  const documentCategories = [
    {
      key: "secured",
      title: "Secured Loans",
      documents: provider?.securedRequiredDocuments || [],
      color: "#52c41a",
    },
    {
      key: "semiSecured",
      title: "Semi-Secured Loans",
      documents: provider?.semiSecuredRequiredDocuments || [],
      color: "#1890ff",
    },
    {
      key: "unsecured",
      title: "Unsecured Loans",
      documents: provider?.unsecuredRequiredDocuments || [],
      color: "#faad14",
    },
    {
      key: "promo100",
      title: "100% Promo Loans",
      documents: provider?.promo100RequiredDocuments || [],
      color: "#722ed1",
    },
  ];

  const totalDocuments = documentCategories.reduce(
    (sum, cat) => sum + cat.documents.length,
    0,
  );

  if (totalDocuments === 0) {
    return (
      <Empty
        description="No required documents configured"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  const columns = [
    {
      title: "Document Name",
      dataIndex: "document",
      key: "document",
      render: (doc: string) => (
        <span>
          <FileTextOutlined style={{ marginRight: 8, color: "#1890ff" }} />
          {getDocumentName(doc)}
        </span>
      ),
    },
  ];

  return (
    <Collapse
    >
      {documentCategories.map((category) => {
        if (category.documents.length === 0) return null;

        const dataSource = category.documents.map((doc: string, index: number) => ({
          key: `${category.key}-${index}`,
          document: doc,
          index,
        }));

        return (
          <Panel
            header={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontWeight: 500 }}>{category.title}</span>
                <Badge style={tabPaneStyle} count={category.documents.length}/>
              </div>
            }
            key={category.key}
          >
            <Table
              columns={columns}
              dataSource={dataSource}
              pagination={false}
              size="small"
            />
          </Panel>
        );
      })}
    </Collapse>
  );
};
